import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumpsService {
  private readonly breadCrumpsList = new BehaviorSubject<any>({});

  setValue(value: string) {
    this.breadCrumpsList.next(value);
  }

  getValue() {
    return this.breadCrumpsList.asObservable();
  }
}
